var React = require('react');

function VideoPlayCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25","cy":"25","r":"25","fill":"#FFDB00","key":0}),React.createElement("path",{"fill":"#191919","d":"M37 25 19 35.392V14.608L37 25Z","key":1})]);
}

VideoPlayCircle.defaultProps = {"viewBox":"0 0 50 50","fill":"none"};

module.exports = VideoPlayCircle;

VideoPlayCircle.default = VideoPlayCircle;
